module.exports = __webpack_public_path__ + "img/pre_banner.4cca8965.png";